// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Timeline — compact variant for CMS admin screens */

.timeline-container {
  position: relative;
  width: 100%;
  padding: 1rem 0;
  font-family: var(--cms-mfe-font-family, 'Inter', system-ui, sans-serif);
  font-size: 0.8125rem;
}

.timeline-line {
  position: absolute;
  left: 50%;
  top: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(to bottom, #e2e8f0, #cbd5e1, #e2e8f0);
  transform: translateX(-50%);
  border-radius: 2px;
}

.timeline-item {
  position: relative;
  display: flex;
  margin: 1.25rem 0;
  opacity: 0;
  transform: translateY(12px);
  transition: opacity 0.4s ease, transform 0.4s ease;
}

.timeline-item.visible {
  opacity: 1;
  transform: translateY(0);
}

.timeline-item.left {
  justify-content: flex-start;
}

.timeline-item.right {
  justify-content: flex-end;
}

.timeline-card {
  width: 45%;
  max-width: 380px;
  background: var(--cms-mfe-color-surface-elevated, #fff);
  border-radius: var(--cms-mfe-radius-md, 8px);
  box-shadow: var(--cms-mfe-shadow-card, 0 1px 2px rgba(0, 0, 0, 0.06));
  transition: all 0.2s ease;
  border: 1px solid var(--cms-mfe-color-border, #e2e8f0);
}

.timeline-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--cms-mfe-shadow-md, 0 4px 16px rgba(0, 0, 0, 0.08));
}

.timeline-card-inner {
  display: flex;
  align-items: flex-start;
  gap: 0.625rem;
  padding: 0.625rem 0.75rem;
}

.timeline-icon-circle {
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  background: var(--cms-mfe-color-surface-muted, #f8fafc);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9375rem;
  color: var(--cms-mfe-color-text, #1e293b);
  border: 1px solid var(--cms-mfe-color-border, #eef2ff);
}

.timeline-content {
  flex: 1;
}

.timeline-date {
  font-size: 0.625rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--cms-mfe-color-text-muted, #64748b);
  margin-bottom: 0.2rem;
}

.timeline-title {
  font-weight: 600;
  font-size: 0.8125rem;
  line-height: 1.35;
  color: var(--cms-mfe-color-text, #0f172a);
  margin-bottom: 0.15rem;
}

.timeline-description {
  font-size: 0.75rem;
  line-height: 1.45;
  color: var(--cms-mfe-color-text-muted, #475569);
  margin-top: 0.15rem;
}

.timeline-dot {
  position: absolute;
  left: 50%;
  top: 1.25rem;
  transform: translateX(-50%);
  width: 10px;
  height: 10px;
  background: white;
  border: 2px solid;
  border-radius: 50%;
  z-index: 2;
}

.timeline-item.left .timeline-card::after,
.timeline-item.right .timeline-card::after {
  content: '';
  position: absolute;
  top: 1.375rem;
  width: 16px;
  height: 1px;
  background: var(--cms-mfe-color-border, #e2e8f0);
}

.timeline-item.left .timeline-card::after {
  right: -16px;
}

.timeline-item.right .timeline-card::after {
  left: -16px;
}

@media (max-width: 768px) {
  .timeline-line {
    left: 1rem;
    transform: none;
  }

  .timeline-item {
    justify-content: flex-start !important;
    margin: 1rem 0;
  }

  .timeline-card {
    width: calc(100% - 2.5rem);
    max-width: none;
    margin-left: 2.5rem;
  }

  .timeline-dot {
    left: 1rem;
    transform: none;
    top: 1rem;
  }

  .timeline-item.left .timeline-card::after,
  .timeline-item.right .timeline-card::after {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/shared/ui/fancy-timeline.css"],"names":[],"mappings":"AAAA,qDAAqD;;AAErD;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,uEAAuE;EACvE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,UAAU;EACV,YAAY;EACZ,iEAAiE;EACjE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,UAAU;EACV,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,uDAAuD;EACvD,4CAA4C;EAC5C,qEAAqE;EACrE,yBAAyB;EACzB,sDAAsD;AACxD;;AAEA;EACE,2BAA2B;EAC3B,oEAAoE;AACtE;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,uDAAuD;EACvD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,yCAAyC;EACzC,sDAAsD;AACxD;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,+CAA+C;EAC/C,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;EACX,gDAAgD;AAClD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,sCAAsC;IACtC,cAAc;EAChB;;EAEA;IACE,0BAA0B;IAC1B,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,eAAe;IACf,SAAS;EACX;;EAEA;;IAEE,aAAa;EACf;AACF","sourcesContent":["/* Timeline — compact variant for CMS admin screens */\r\n\r\n.timeline-container {\r\n  position: relative;\r\n  width: 100%;\r\n  padding: 1rem 0;\r\n  font-family: var(--cms-mfe-font-family, 'Inter', system-ui, sans-serif);\r\n  font-size: 0.8125rem;\r\n}\r\n\r\n.timeline-line {\r\n  position: absolute;\r\n  left: 50%;\r\n  top: 0;\r\n  width: 2px;\r\n  height: 100%;\r\n  background: linear-gradient(to bottom, #e2e8f0, #cbd5e1, #e2e8f0);\r\n  transform: translateX(-50%);\r\n  border-radius: 2px;\r\n}\r\n\r\n.timeline-item {\r\n  position: relative;\r\n  display: flex;\r\n  margin: 1.25rem 0;\r\n  opacity: 0;\r\n  transform: translateY(12px);\r\n  transition: opacity 0.4s ease, transform 0.4s ease;\r\n}\r\n\r\n.timeline-item.visible {\r\n  opacity: 1;\r\n  transform: translateY(0);\r\n}\r\n\r\n.timeline-item.left {\r\n  justify-content: flex-start;\r\n}\r\n\r\n.timeline-item.right {\r\n  justify-content: flex-end;\r\n}\r\n\r\n.timeline-card {\r\n  width: 45%;\r\n  max-width: 380px;\r\n  background: var(--cms-mfe-color-surface-elevated, #fff);\r\n  border-radius: var(--cms-mfe-radius-md, 8px);\r\n  box-shadow: var(--cms-mfe-shadow-card, 0 1px 2px rgba(0, 0, 0, 0.06));\r\n  transition: all 0.2s ease;\r\n  border: 1px solid var(--cms-mfe-color-border, #e2e8f0);\r\n}\r\n\r\n.timeline-card:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: var(--cms-mfe-shadow-md, 0 4px 16px rgba(0, 0, 0, 0.08));\r\n}\r\n\r\n.timeline-card-inner {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 0.625rem;\r\n  padding: 0.625rem 0.75rem;\r\n}\r\n\r\n.timeline-icon-circle {\r\n  flex-shrink: 0;\r\n  width: 2rem;\r\n  height: 2rem;\r\n  background: var(--cms-mfe-color-surface-muted, #f8fafc);\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 0.9375rem;\r\n  color: var(--cms-mfe-color-text, #1e293b);\r\n  border: 1px solid var(--cms-mfe-color-border, #eef2ff);\r\n}\r\n\r\n.timeline-content {\r\n  flex: 1;\r\n}\r\n\r\n.timeline-date {\r\n  font-size: 0.625rem;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  color: var(--cms-mfe-color-text-muted, #64748b);\r\n  margin-bottom: 0.2rem;\r\n}\r\n\r\n.timeline-title {\r\n  font-weight: 600;\r\n  font-size: 0.8125rem;\r\n  line-height: 1.35;\r\n  color: var(--cms-mfe-color-text, #0f172a);\r\n  margin-bottom: 0.15rem;\r\n}\r\n\r\n.timeline-description {\r\n  font-size: 0.75rem;\r\n  line-height: 1.45;\r\n  color: var(--cms-mfe-color-text-muted, #475569);\r\n  margin-top: 0.15rem;\r\n}\r\n\r\n.timeline-dot {\r\n  position: absolute;\r\n  left: 50%;\r\n  top: 1.25rem;\r\n  transform: translateX(-50%);\r\n  width: 10px;\r\n  height: 10px;\r\n  background: white;\r\n  border: 2px solid;\r\n  border-radius: 50%;\r\n  z-index: 2;\r\n}\r\n\r\n.timeline-item.left .timeline-card::after,\r\n.timeline-item.right .timeline-card::after {\r\n  content: '';\r\n  position: absolute;\r\n  top: 1.375rem;\r\n  width: 16px;\r\n  height: 1px;\r\n  background: var(--cms-mfe-color-border, #e2e8f0);\r\n}\r\n\r\n.timeline-item.left .timeline-card::after {\r\n  right: -16px;\r\n}\r\n\r\n.timeline-item.right .timeline-card::after {\r\n  left: -16px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .timeline-line {\r\n    left: 1rem;\r\n    transform: none;\r\n  }\r\n\r\n  .timeline-item {\r\n    justify-content: flex-start !important;\r\n    margin: 1rem 0;\r\n  }\r\n\r\n  .timeline-card {\r\n    width: calc(100% - 2.5rem);\r\n    max-width: none;\r\n    margin-left: 2.5rem;\r\n  }\r\n\r\n  .timeline-dot {\r\n    left: 1rem;\r\n    transform: none;\r\n    top: 1rem;\r\n  }\r\n\r\n  .timeline-item.left .timeline-card::after,\r\n  .timeline-item.right .timeline-card::after {\r\n    display: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
